import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import { request } from 'axios/request.js';

const $P = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/packageOrderDetail`);
const $A = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/app`);

let _content = null;

export const PrintButton = ({ selectedRowKeys, statusId, enumValue, url, erpCode }) => {
  const componentRef = React.useRef(null);
  const [loading, setLoading] = useState(false);
  const [modalReady, setModalReady] = useState(false);
  const [data, setData] = useState([]);
  const [uncheckedList, setUncheckedList] = useState({});

  const reactToPrintContent = React.useCallback(() => {
    return componentRef.current;
  }, [componentRef.current]);

  const isPrintable = (number) => {
    if (uncheckedList[number] === undefined) {
      return true;
    }
    return uncheckedList[number];
  };

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: 'AwesomeFileName',
    removeAfterPrint: true,
    onAfterPrint: () => {
      setLoading(false);
      setModalReady(false);
      setUncheckedList([]);
    },
  });

  const handleCheckboxChange = (e, number) => {
    const { checked } = e.target;
    setUncheckedList({ ...uncheckedList, [number]: checked });
  };

  // enum_value = transferred ==> Teslim edildi statüsü.
  const isCheckboxDisabled = enumValue === 'transferred';

  const filterItems = (data) => {
    return data.filter((_packageItem) =>
      selectedRowKeys.includes(_packageItem.id)
    );
  };

  useEffect(() => {
    if (loading && !modalReady) {
      const isBrandKoton = $A.BRAND === 'Koton'
      const alteredUrl = `${url}?state=${statusId}&limit=9999${isBrandKoton ? `&destination__erp_code=${erpCode}` : ''}`
      request({
        url: alteredUrl,
        method: 'get',
      }).then((response) => {
        if (response.data && response.data.results) {
          const data = filterItems(response.data.results);

          setData(data);
          setModalReady(true);
        }
      });
    }
  }, [loading, modalReady, statusId]);

  const loadData = () => {
    setLoading(!loading);
  };

  const extractAttributes = (product) => {
    const erp_barcode =
      $P.PACKAGE_ITEM.ORDER_ITEM.PRODUCT.CODE_TO_SCAN.split('.')[1] ||
      $P.PACKAGE_ITEM.ORDER_ITEM.PRODUCT.CODE_TO_SCAN;
    const erp_color = $P.PACKAGE_ITEM.ORDER_ITEM.PRODUCT.COLOR.split('.')[1];
    const erp_size = $P.PACKAGE_ITEM.ORDER_ITEM.PRODUCT.SIZE.split('.')[1];

    const colorCode = product.attributes[erp_color] || '';
    const barcode =
      product.attributes[erp_barcode] || product[erp_barcode] || '';
    const size = product.attributes[erp_size] || '';
    return { colorCode, barcode, size };
  };

  return (
    _content &&
    _content({
      selectedRowKeys,
      statusId,
      enumValue,
      url,
      componentRef,
      loading,
      modalReady,
      data,
      uncheckedList,
      isCheckboxDisabled,
      reactToPrintContent,
      isPrintable,
      handlePrint,
      handleCheckboxChange,
      loadData,
      extractAttributes,
      setModalReady,
      setLoading,
      setUncheckedList,
    })
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default function (content) {
  _content = content;
  return connect(mapStateToProps, mapDispatchToProps)(PrintButton);
}



// WEBPACK FOOTER //
// ./src/_pageContainers/oms/TransferOrderList/printableView/index.js